require("./toaster.js");
module.exports = "toaster";



/*****************
 ** WEBPACK FOOTER
 ** ./~/angularjs-toaster/index.js
 ** module id = 503
 ** module chunks = 2
 **/